import { FC } from "react";
import { Loader } from "@monolith-forensics/monolith-ui";
import { DataImportModal } from "../../_components/DataImport";
import { useCaseContext } from "@/Features/Cases";
import { useEvidenceImportDefinition } from "../Import";

interface EvidenceDataImportModalProps {
  open: boolean;
  onClose: () => void;
  onComplete?: () => void;
}

export const EvidenceDataImportModal: FC<EvidenceDataImportModalProps> = ({
  open,
  onClose,
  onComplete,
}) => {
  const caseContext = useCaseContext();
  const { definition, isLoading } = useEvidenceImportDefinition({
    case_id: caseContext?.data?.case_id,
  });

  if (isLoading || !definition) {
    if (open) {
      return (
        <div
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <Loader />
        </div>
      );
    }
    return null;
  }

  return (
    <DataImportModal
      open={open}
      onClose={onClose}
      definition={definition}
      onComplete={onComplete}
    />
  );
};
